import styled from 'styled-components';

import { P2 } from '~/components';
import { colors, typograph, breakpoints } from '~/styles';

const { gray, primary } = colors;
const { weight, size } = typograph;

/**
 * Container principal do formulário
 * Segue o padrão do DuplicitySettings
 */
export const MainForm = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-radius: 8px;
  & > div {
    display: flex;
    align-items: center;
    gap: 2rem;
    flex: 1;

    & > p {
      color: #7F859D;
      font-size: 1.6rem;
      margin: 0;
      flex: 1;
    }
  }
`;

/**
 * Container do conteúdo do modal
 * Segue o padrão do RiskSettings
 */
export const ModalView = styled.div`
  display: flex !important;
  flex-direction: column;

  & > p {
    color: #7F859D;
    margin-bottom: 2rem;
    font-size: 1.6rem;
    line-height: 1.5;
  }

  & > div {
    margin-bottom: 1.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  /* Estilo para os checkboxes */
  & > div > label {
    font-size: 1.6rem;
    font-weight: 500;
    color: #7F859D;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 0;
    transition: color 0.2s ease;

    &:hover {
      color: #000;
    }
  }

  /* Responsividade */
  @media (max-width: ${breakpoints.tablet}) {
    & > p {
      font-size: ${size.s3};
    }

    & > div > label {
      font-size: ${size.s3};
    }
  }
`;
